interface Props {
  summary: string;
}

export function IndependentReadingPanel({ summary }: Props) {
  return (
    <details className="independent-reading-panel">
      <summary className="independent-reading-panel__toggle">
        Nezávislé čtení (Stage 3 — Krok A)
      </summary>
      <p className="independent-reading-panel__body">{summary}</p>
    </details>
  );
}
